Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconCaretUpData: "data:image/svg+xml,%3csvg width='10' height='6' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M9 5L5 1 1 5z' fill='currentColor' fill-rule='nonzero' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/svg%3e",
  iconCaretUpWidth: 10,
  iconCaretUpHeight: 6
};